import {responseMsg} from "../../common/ResponseMsg";
import {useForm} from "react-hook-form";
import Flex from "../../../shared/components/Flex";
import ModalButton from "../../../shared/components/ModalButton";
import LabelInput from "../../../shared/components/LabelInput";
import Spacer from "../../../shared/components/Spacer";
import useDevice from "../../../shared/hooks/useDevice";
import { useAlert } from "../../../shared/components/AlertProvider";

function AllianceAddModal({rendering}) {
    const { register, handleSubmit, formState: { isSubmitting, isDirty, errors }} = useForm();
    const device = useDevice();
    const isMobile = device !== 'desktop';
    const showAlert = useAlert();

    const onSubmitHandler = (formData) => {
        if (formData.allianceCode.trim() === '') {
            showAlert({title: "주의", text: "소속코드를 입력해주세요.", type: "warning" });
            return;
        } else if (formData.allianceName.trim() === '') {
            showAlert({title: "주의", text: "소속명을 입력해주세요.", type: "warning" });
            return;
        }

        fetch("/api/system/alliances",{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "등록완료"});
                    rendering();

                }  else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }

    return (
        <div>
            <form className="input_wrap">
                <LabelInput id="regionAuthId" label={'소속코드'} placeholder="소속코드를 입력해 주세요" maxLength={40} required autoFocus {...register("allianceCode")}/>
                <Spacer direction="vertical" size={25} />
                <LabelInput id="regionAuthName" label={'소속명'} placeholder="소속명을 입력해 주세요" maxLength={200} required {...register("allianceName")}/>

                <Spacer direction="vertical" size={40} />

                <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                    <ModalButton type='insert' onClick={handleSubmit(onSubmitHandler)} />
                    <ModalButton type='cancel' onClick={rendering} />
                </Flex>
            </form>

        </div>
    );
}

export default AllianceAddModal;